'use client';

import React, { useId, useState } from 'react';

import classNames from 'classnames';

import { ChevronIcon } from '@/components/ui/Icons';

export type TypeUseAccordionProps = {
  defaultIsOpen?: boolean;
};

export const useAccordion = (props?: TypeUseAccordionProps) => {
  const [isOpen, setIsOpen] = useState(props?.defaultIsOpen || false);

  const accordionId = useId();

  const Icon = ({ className }: { className?: string }) => (
    <ChevronIcon
      classes={`md:w-[24px] md:h-[24px] w-[20px] h-[20px] ${className}`}
      direction={isOpen ? 'up' : 'down'}
    />
  );

  const Accordion = ({
    collapsedContent,
    expandedContent,
  }: {
    collapsedContent: React.ReactNode;
    expandedContent: React.ReactNode;
  }) => (
    <div className="border-b border-y-charcoal-opacity-20">
      <div
        id={accordionId}
        aria-expanded={isOpen}
        aria-controls={`sect-${accordionId}`}
        role="button"
        onClick={() => setIsOpen(!isOpen)}
        className={classNames(
          'accordion collapse mx-auto w-full',
          isOpen ? 'collapse-open' : 'collapse-close',
        )}
      >
        {collapsedContent}
      </div>
      {isOpen && expandedContent}
    </div>
  );

  return {
    Icon,
    Accordion,
  };
};
